import { useQuery } from "@tanstack/react-query";
import { launcher, launcherAvailable, type LauncherHome } from "./launcherApi.js";
import { useLauncher } from "./launcherStore.js";

/**
 * Launcher mode's data, shared by the top bar's links and Home's Apps row (one query, one
 * native call). Read again whenever the viewer comes back from another app, so a just-installed
 * app or a just-plugged-in input is there. `home` is undefined when launcher mode is off.
 */
export function useLauncherHome(): { on: boolean; home: LauncherHome | undefined } {
  const on = useLauncher((s) => s.enabled) && launcherAvailable();
  const query = useQuery({
    queryKey: ["launcher-home"],
    queryFn: launcher.home,
    enabled: on,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
  return { on, home: on ? query.data : undefined };
}
